import '.am{position:relative;}.ssr-plugin'
import '.js{width:64px;}.ssr-plugin'
import '.jt{height:64px;}.ssr-plugin'
import '.ag{flex-shrink:0;}.ssr-plugin'
import '.bg{position:absolute;}.ssr-plugin'
import '.ju{bottom:-4px;}.ssr-plugin'
import '.hg{right:-4px;}.ssr-plugin'
import '.fs{border-radius:50%;}.ssr-plugin'
import '.dd{border:2px solid var(--palette-white);}.ssr-plugin'
import '.c1{overflow:hidden;}.ssr-plugin'
import '.jv{width:32px;}.ssr-plugin'
import '.jw{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="am js jt ag"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bg ju hg fs dd c1 jv jw"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
